// Estilos y filtro de estados de transaccion del dashboard de Soporte.
export const STATUS_STYLES = {
  created:           { bg: "#111811", text: "#9ca3af", label: "Creada" },
  pending_otp:       { bg: "#1a1400", text: "#fbbf24", label: "Esperando OTP" },
  executing:         { bg: "#1a1f0d", text: "#a3e635", label: "Ejecutando" },
  processing:        { bg: "#1a1f0d", text: "#a3e635", label: "Procesando" },
  awaiting_funding:  { bg: "#1a1a1a", text: "#c4b5fd", label: "Esperando fondos" },
  // OPS-29: ejecutada, esperando que el destinatario se verifique (o que venza).
  pending_claim:     { bg: "#1a1400", text: "#fbbf24", label: "Pendiente de reclamo" },
  completed:         { bg: "#0d2b1a", text: "#34d399", label: "Completada" },
  failed:            { bg: "#2b0d0d", text: "#f87171", label: "Fallida" },
  reversed:          { bg: "#1a1a1a", text: "#fca5a5", label: "Revertida" },
};

export const TX_STATUS_FILTERS = [
  "all", "created", "pending_otp", "executing", "processing", "awaiting_funding",
  "pending_claim", "completed", "failed", "reversed",
];

export function statusStyle(status) {
  return STATUS_STYLES[status] || STATUS_STYLES.failed;
}
